import DownloadIcon from "@mui/icons-material/Download";
import {Link, Stack, Typography} from "@mui/material";
import cvFile from "../assets/CV_Cristian_Hilohi.pdf";
import WorkIcon from '@mui/icons-material/Work';
import WorkHistoryIcon from '@mui/icons-material/WorkHistory';
import SchoolIcon from '@mui/icons-material/School';

export const CVSection = () => {
    const startDate = new Date(2023, 7, 16); // Months are 0-indexed → 7 = August

    // returns x years y months from startDate
    const currentJobTime = (() => {
        const now = new Date();

        let years = now.getFullYear() - startDate.getFullYear();
        let months = now.getMonth() - startDate.getMonth();

        if (months < 0) {
            years--;
            months += 12;
        }

        return `${years} year${years !== 1 ? 's' : ''} ${months} month${months !== 1 ? 's' : ''}`;
    })();

    return (
        <Stack spacing={2}>
            {/* Plain-text summary sentence: gives crawlers one dense, keyword-
                bearing sentence with your name + role + stack, independent of
                the link-heavy list below (search engines weight plain
                sentence text differently from anchor text). Visually this is
                just another line, styled to match the rest. */}
            <Typography color="text.secondary">
                Cristian Hilohi is an entrepreneur and software developer with experience in
                React, React Native, Angular, Jetpack Compose and Ktor, currently
                working at Advahoo and developing own applications.
            </Typography>

            <Stack direction="row" alignItems="center" spacing={1}>
                <DownloadIcon color="secondary"/>
                <Link
                    href={cvFile}
                    download="CV Cristian Hilohi.pdf"
                    underline="hover"
                >
                    <Typography color="primary">CV.pdf</Typography>
                </Link>
            </Stack>

            <Stack direction="row" alignItems="center" spacing={1}>
                <WorkIcon color="secondary"/>
                <Typography>
                    Working as front-end developer at{" "}
                    <Link sx={{textDecoration: 'none'}} underline="hover" href="https://www.advahoo.ro/"
                          target="_blank">
                        Advahoo
                    </Link>
                    <Typography color="text.secondary">
                        {currentJobTime}
                    </Typography>
                </Typography>
            </Stack>

            <Stack direction="row" alignItems="center" spacing={1}>
                <WorkHistoryIcon color="secondary"/>
                <Typography>
                    Worked as front-end developer (contractor) for{" "}
                    <Link sx={{textDecoration: 'none'}} underline="hover" href="https://soft-state.com/"
                          target="_blank">
                        SoftState Technologies
                    </Link>
                    <Typography color="text.secondary">
                        (4 months)
                    </Typography>
                </Typography>
            </Stack>

            <Stack direction="row" alignItems="center" spacing={1}>
                <WorkHistoryIcon color="secondary"/>
                <Typography>
                    Worked as front-end developer at{" "}
                    <Link sx={{textDecoration: 'none'}} underline="hover" href="https://myonvent.com/" target="_blank">
                        myOnvent
                    </Link>
                    <Typography color="text.secondary">
                        (11 months)
                    </Typography>
                </Typography>
            </Stack>

            <Stack direction="row" alignItems="center" spacing={1}>
                <WorkHistoryIcon color="secondary"/>
                <Typography>
                    Worked as front-end developer at{" "}
                    <Link sx={{textDecoration: 'none'}} underline="hover" href="https://cst.ro/" target="_blank">
                        Cornerstone Technologies
                    </Link>
                    <Typography color="text.secondary">
                        (internship)
                    </Typography>
                </Typography>
            </Stack>

            <Stack direction="row" alignItems="center" spacing={1}>
                <WorkHistoryIcon color="secondary"/>
                <Typography>
                    Worked as back-end developer at{" "}
                    <Link sx={{textDecoration: 'none'}} underline="hover" href="https://www.coconet.de/en/"
                          target="_blank">
                        Coconet
                    </Link>
                    <Typography color="text.secondary">
                        (internship)
                    </Typography>
                </Typography>
            </Stack>

            <Stack direction="row" alignItems="center" spacing={1}>
                <SchoolIcon color="secondary"/>
                <Typography>
                    Studied computer science at {" "}
                    <Link sx={{textDecoration: 'none'}} underline="hover" href="https://fmi.unibuc.ro/"
                          target="_blank">
                        Facultatea de Matematică și Informatică
                    </Link>
                    <br/>
                    from{" "}
                    <Link sx={{textDecoration: 'none'}} underline="hover" href="https://unibuc.ro/"
                          target="_blank">
                        Universitatea București
                    </Link>
                    <Typography color="text.secondary">
                        (bachelors degree)
                    </Typography>
                </Typography>
            </Stack>

            <Stack direction="row" alignItems="center" spacing={1}>
                <SchoolIcon color="secondary"/>
                <Typography>
                    Studied at{" "}
                    <Link sx={{textDecoration: 'none'}} underline="hover" href="https://www.saguna.ro/"
                          target="_blank">
                        Colegiul Național Andrei Șaguna
                    </Link>
                    <Typography color="text.secondary">
                        (highschool)
                    </Typography>
                </Typography>
            </Stack>
        </Stack>
    )
}